/* eslint-disable no-else-return */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Spacings } from '@styles/index';

const StyledCarousel = styled.div`
  display: grid;
  grid-template-columns: repeat(18, 32px);
  grid-column-gap: ${Spacings.SPACING_4B};
  grid-column: span 18;
  @media only screen and (max-width: 47.95em) {
    grid-template-columns: repeat(10, 1fr);
    grid-column: span 11;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    padding: 0 16px;
  }
`;

const CourseCarousel = ({ number, children }) => (
  <StyledCarousel $number={number}>{children}</StyledCarousel>
);

CourseCarousel.propTypes = {
  number(props, propName, componentName) {
    if (typeof props[propName] !== 'number') {
      return new Error(
        `Invalid type of ${propName} supplied to ${componentName} Validation failed.`
      );
    } else if (props[propName] > 3) {
      return new Error(
        `Expected max value for ${propName} is 3 but supplied greater value to ${componentName} Validation failed.`
      );
    }
  },
  children: PropTypes.node.isRequired
};

CourseCarousel.defaultProps = {
  number: 3
};

export default CourseCarousel;
